// extracted by mini-css-extract-plugin
module.exports = {"body":"src-components-NotificationMessage-styles___body","meta":"src-components-NotificationMessage-styles___meta"};